import React, { useState, useEffect } from "react";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { CustomInputText } from "../../CustomInputText";
import { Add, Remove } from "@mui/icons-material";
import { convertirLetraMayus } from "../../../helpers/convertirLetraMayus";

export const DynamicsField = (props) => {

    const { data, name, label, controller: Controller, control, resetField, errors, unregister, disabled } = props;
    const [ options, setOptions ] = useState(data || []);
    const [actualNameOption, setActualNameOption] = useState(name?.nombre);

    useEffect(() => {
        if(!actualNameOption?.includes(name?.nombre)) {
            setActualNameOption(name?.nombre);
            options?.map((o, i) => {
                resetField(`opcion${ i }`);
                return unregister(`opcion${ i }`);
            });
            setOptions(['']);
        }
    }, [name]);

    const handleClickAdd = () => {
        setOptions(prev => ([ ...prev, '' ]));
    }

    const handleClickRemove = () => {
        unregister(`opcion${ options.length - 1 }`);
        let newArray = [...options.slice(1)];
        setOptions(newArray);
    }

    if(name?.nombre?.toLowerCase().includes('linea')) return <></>;
    if(name?.nombre?.toLowerCase().includes('multilinea')) return <></>;

    return (
        <div style={{ display: 'flex', flexFlow: 'column noWrap', gap: 5, marginBottom: 15 }}>
            <label style={{ fontWeight: 600, fontSize: 14 }} htmlFor="select">{ label }</label>
            <Grid container spacing={1}>
                {
                    options?.map((o, index) => (
                        <Grid key={ index.toString() } item xs={2} md={ 6 } lg={ 6 }>
                            <Controller
                                name={ `opcion${ index }` }
                                control={ control }
                                defaultValue={ options[index] || '' }
                                render={({ field: { onChange, value } }) => (
                                    <CustomInputText
                                        placeholder={ 
                                            name?.nombre.includes('decisión') ? 'A-Z' 
                                            : name?.nombre.includes('selección') 
                                            ? 'Texto' 
                                            : (name?.nombre?.includes('satisfacción') || name?.nombre?.includes('recomendación'))
                                            ? '0-9' : '' }
                                        onChange={ e => {
                                            onChange(e.target.value.toLowerCase());
                                        }}
                                        value={ convertirLetraMayus(value) }
                                        error={ errors[`opcion${ index  }`] }
                                        disabled={ disabled }
                                    />
                                )}
                                rules={{
                                    required: '*',
                                    pattern: {
                                        value: name?.nombre.includes('decisión') ? /^[a-zA-Z]{2,}$/ : name?.nombre.includes('selección') ? /^[a-zA-Z].+$/ : (name?.nombre.includes('satisfacción') || name?.nombre.includes('recomendación')) && /^[0-9]{1,2}$/,
                                        message: name?.nombre.includes('decisión') ? 'A-Z' : name?.nombre.includes('selección') ? 'Texto' : (name?.nombre.includes('satisfacción') || name?.nombre.includes('recomendación')) && '0-9',
                                    },
                                    // validate: () => {
                                    //     return validateTramit(getValues(`Opción${index + 1 }`));
                                    // }
                                }}
                            />
                        </Grid>
                    ))
                }
            </Grid>
            
            {
                !disabled && (
                    <div>
                        {
                            name?.nombre?.toLowerCase().includes('selección') ? (
                                <Tooltip title='Añadir'>
                                    <IconButton onClick={ handleClickAdd }>
                                        <Add color='action' fontSize='small' />
                                    </IconButton>
                                </Tooltip>
                            ) : options?.length < 11 && (
                                <Tooltip title='Añadir'>
                                    <IconButton onClick={ handleClickAdd }>
                                        <Add color='action' fontSize='small' />
                                    </IconButton>
                                </Tooltip>
                            )
                        }
                  
                        {
                            options?.length > 1 && (
                                <Tooltip title='Remover'>
                                    <IconButton onClick={ handleClickRemove }>
                                        <Remove color='action' fontSize='small' />
                                    </IconButton>
                                </Tooltip>
                            )
                        }
                    </div>
                )
            }
        </div>
    )
};

DynamicsField.defaultProps = {
    name: '',
    data: [''],
    label: 'Opciones',
    controller: () => false,
    control: () => false,
    unregister: () => false,
    errors: {},
    disabled: false
}